type ConfirmOptions = { title: string; message: string; onConfirm: () => void; onCancel?: () => void };
type AlertOptions = { title?: string; message: string; onClose?: () => void };

class ModalService {
  private confirmHandler: ((options: ConfirmOptions) => void) | null = null;
  private alertHandler: ((options: AlertOptions) => void) | null = null;

  setHandlers(
    confirmHandler: (options: ConfirmOptions) => void,
    alertHandler: (options: AlertOptions) => void
  ) {
    this.confirmHandler = confirmHandler;
    this.alertHandler = alertHandler;
  }

  showConfirm(title: string, message: string, onConfirm: () => void, onCancel?: () => void) {
    if (this.confirmHandler) {
      this.confirmHandler({ title, message, onConfirm, onCancel });
    } else {
      console.warn("GlobalModal is not mounted. Cannot show confirm.");
    }
  }

  showAlert(message: string, title?: string, onClose?: () => void) {
    if (this.alertHandler) {
      this.alertHandler({ message, title, onClose });
    } else {
      console.warn("GlobalModal is not mounted. Cannot show alert.");
    }
  }
}

const modalService = new ModalService();

export const getModalService = () => modalService;

export const showConfirm = (title: string, message: string, onConfirm: () => void, onCancel?: () => void) => {
  modalService.showConfirm(title, message, onConfirm, onCancel);
};

export const showAlert = (message: string, title?: string, onClose?: () => void) => {
  modalService.showAlert(message, title, onClose);
};
